import { pdf } from '@react-pdf/renderer';
import { IntlFormatters } from '@formatjs/intl/src/types';
import * as Sentry from '@sentry/browser';

import { getFullName, startLoading, stopLoading } from 'lib/utils';
import { metrics } from './metrics';
import { ResumePdf } from './ResumePdf/ResumePdf';

export const downloadPdf = ({
  formatDate,
  formatMessage,
  profile,
  onError,
}: {
  formatDate: IntlFormatters['formatDate'];
  formatMessage: IntlFormatters['formatMessage'];
  profile: AH$Profile;
  onError?: () => void;
}) => {
  startLoading();
  pdf(<ResumePdf profile={profile} formatMessage={formatMessage} formatDate={formatDate} />)
    .toBlob()
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');

      a.href = url;
      a.download = `${getFullName(profile, '_')}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      metrics.downloadPdf();
    })
    .catch((error) => {
      Sentry.withScope((scope) => {
        scope.setTag('feature', 'resume-export');
        scope.setTag('format', 'pdf');
        scope.setExtra('profileId', profile.id);
        scope.setExtra('docId', profile.docId);
        scope.setExtra('photo', profile.photo);
        Sentry.captureException(error);
      });
      onError?.();
    })
    .finally(() => {
      stopLoading();
    });
};
